//@flow

import React from 'react';

import makeUrl from '../../lib/makeUrl';
import type { TrekData } from '../../types/cards';
import { CardBodyBottom, CardBodyTop, HGCardBase, RatingAndPrice } from './Common';

type Props = { cardData: TrekData };

const TrekCard = (props: Props) => {
  const {
    name,
    number_of_days,
    reviews,
    creator_name,
    average_rating,
    id,
    region,
    is_guided,
    is_template,
  } = props.cardData;
  const { mobile } = props;
  const goToUrl = makeUrl.trekOverview(name, id, region);
  const ribbonText = is_guided && is_template ? 'EXPERIENCES' : '';

  return (
    <HGCardBase
      className={`trrekCard ${mobile ? 'mobile' : ''}`}
      cardData={props.cardData}
      url={goToUrl}
      ribbon={ribbonText}
    >
      <CardBodyTop title={name} type="trek" url={goToUrl}>
        {creator_name && (
          <div className="owner">
            Created by {creator_name}
            {/* <a href={makeUrl.goToProfile(creatorId)}>{creator_name}</a> */}
          </div>
        )}

        {number_of_days && <p className="dayCount">{number_of_days} Days Trek</p>}
      </CardBodyTop>

      <CardBodyBottom>
        <RatingAndPrice
          // price={starting_price}
          average_rating={average_rating}
          reviews={reviews}
        />
      </CardBodyBottom>
    </HGCardBase>
  );
};

export default TrekCard;



// WEBPACK FOOTER //
// ./src/components/Cards/TrekCard.jsx